exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.occupancyReportTable {\n  width: 100%;\n  border: 1px solid darkgray;\n}\n.occupancyReportRowTitle {\n  width: 70%;\n  font-family: \"Montserrat\";\n  font-size: 16px;\n}\n.occupancyReportRowLabel {\n  font-family: \"Montserrat\";\n  font-size: 14px;\n  font-style: italic;\n  border: none;\n}\n.occupancyReportRowValue {\n  font-size: 14px;\n  font-family: \"Montserrat\";\n  padding-left: 10px;\n}\n.occupancyReportTitle {\n  font-size: 20px;\n  font-weight: bold;\n  margin-top: 10px;\n}\n", ""]);

// exports
